import React from "react";
import { SubHeading } from "../../components";
import {
	BsInstagram,
	BsFillTelephoneFill,
	BsFacebook,
	BsEnvelope,
} from "react-icons/bs";
import "./FindUs.css";

const FindUs = () => (
	<div
		className="app__contact app__wrapper app__bg section__padding"
		id="contact"
	>
		<div className="app__contact_wrapper_info">
			<SubHeading title="Contact" />
			<h1 className="headtext__cormorant">Find Us</h1>
			<div className="app__contact_info-container">
				<div className="app__contact_info-content">
					<ul>
						<li>
							{" "}
							<BsFacebook /> &nbsp;&nbsp;&nbsp;&nbsp;{" "}
							<a href="https://www.facebook.com/marymatha2013">
								{" "}
								Facebook &nbsp;&nbsp;&nbsp;&nbsp;{" "}
							</a>{" "}
						</li>
						<li>
							{" "}
							<BsInstagram /> &nbsp;&nbsp;&nbsp;&nbsp;{" "}
							<a href="http://instagram.com/_m.a.r.y.m.a.t.h.a_catering_/">
								{" "}
								Instagram &nbsp;{" "}
							</a>{" "}
						</li>
						<li>
							{" "}
							<BsEnvelope /> &nbsp;&nbsp;&nbsp;&nbsp;{" "}
							<a href="mailto:marymathaestd2013@gmail.com">
								{" "}
								marymathaestd2013@gmail.com{" "}
							</a>{" "}
						</li>
						<li>
							{" "}
							<BsFillTelephoneFill /> &nbsp;&nbsp;&nbsp;&nbsp;{" "}
							<a href="tel:04752277573">04752277573</a>,{" "}
							<a href="tel:+919497621487">9497621487</a>{" "}
						</li>
					</ul>
				</div>
				<div>
					<iframe
						className="app__contact-map"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4090.414266928955!2d76.89050624469347!3d8.918707867947901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b05df15d25be17d%3A0xa379d28ca67b0e58!2sMary%20Matha%20Catering%20Service!5e1!3m2!1sen!2sus!4v1687936599108!5m2!1sen!2sus"
						allowfullscreen="1"
						loading="lazy"
						referrerpolicy="no-referrer-when-downgrade"
					></iframe>
				</div>
			</div>
		</div>
	</div>
);

export default FindUs;
